import { render, staticRenderFns } from "./FrameDetail.vue?vue&type=template&id=67f5c218&"
import script from "./FrameDetail.vue?vue&type=script&lang=js&"
export * from "./FrameDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports